import { Component, ViewEncapsulation } from '@angular/core';
import { Configuration } from '../../../configuration';

@Component({
    selector: 'anonymous',
    template: require('./anonymous.component.html'),
    styles: [require('./basic.component.css'), require('./environment.banner.css')],
    encapsulation: ViewEncapsulation.None
})
export class AnonymousComponent {
    constructor(public configuration: Configuration) { }

    public notificationOptions = {
        position: ['top', 'right'],
        timeOut: 5000
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/layouts/anonymous.component.ts